var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-child"},[_vm._v("\n    CHILD:["+_vm._s(_vm.name)+"]\n")])}
var staticRenderFns = []

export { render, staticRenderFns }